import React from "react";
import CustomDrawer from "./drawer";

function DrawerSideBar({ isAdmin, mobileOpen, handleDrawerTransitionEnd, handleDrawerClose, ProjectVersion, sizeOfMenuDrawer }) {
    return (
        <CustomDrawer
            sizeOfMenuDrawer={sizeOfMenuDrawer}
            isAdmin={isAdmin}
            ProjectVersion={ProjectVersion}
            mobileOpen={mobileOpen}
            handleDrawerTransitionEnd={handleDrawerTransitionEnd}
            handleDrawerClose={handleDrawerClose}
        />
    );
}

export default DrawerSideBar;